import { Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { type FC } from "react";
import { FormattedMessage, type IntlShape, useIntl } from "react-intl";
import { useToken } from "@packsize/authentication";

import { Loading } from "@/components/loading";

const getSimulators = (intl: IntlShape) => [
	{
		key: "cvp-range-simulator",
		label: intl.formatMessage({ id: "CVP Range Simulator", defaultMessage: "CVP Range Simulator" }),
	},
	{ key: "em-simulator", label: intl.formatMessage({ id: "EM Simulator", defaultMessage: "EM Simulator" }) },
	{
		key: "fusion-simulator",
		label: intl.formatMessage({ id: "Fusion Simulator", defaultMessage: "Fusion Simulator" }),
	},
	{
		key: "lantech-cs-simulator",
		label: intl.formatMessage({ id: "ClosePro X Simulator", defaultMessage: "ClosePro X Simulator" }),
	},
	{
		key: "pl1-simulator",
		label: intl.formatMessage({ id: "LidPro X Simulator", defaultMessage: "LidPro X Simulator" }),
	},
	{
		key: "seal-pro-x-simulator",
		label: intl.formatMessage({ id: "SealPro X Simulator", defaultMessage: "SealPro X Simulator" }),
	},
	{ key: "x4-simulator", label: intl.formatMessage({ id: "X4 Simulator", defaultMessage: "X4 Simulator" }) },
	{ key: "x5-simulator", label: intl.formatMessage({ id: "X5 Simulator", defaultMessage: "X5 Simulator" }) },
	{ key: "x6-simulator", label: intl.formatMessage({ id: "X6 Simulator", defaultMessage: "X6 Simulator" }) },
	{ key: "zebra-simulator", label: intl.formatMessage({ id: "Zebra Simulator", defaultMessage: "Zebra Simulator" }) },
];

export const SimulatorCard: FC = () => {
	const intl = useIntl();
	const { bearerToken, decodedToken } = useToken();

	const handleOpenSimulatorClicked = (simulatorName: string) => {
		if (!bearerToken) {
			return;
		}

		window.localStorage.setItem("BEARER", bearerToken);
		window.open(`/${simulatorName}/tenants/${decodedToken?.Tenant}/simulators`, "_blank");
	};

	if (!decodedToken) {
		return <Loading />;
	}

	return (
		<Card id="developer-simulators">
			<CardContent>
				<Typography variant="h3" component="h2" gutterBottom>
					<FormattedMessage id="Simulators" defaultMessage="Simulators" />
				</Typography>

				<Grid container spacing={2} display="grid" gridTemplateColumns="repeat(3, 1fr)">
					{getSimulators(intl).map(({ key, label }) => (
						<Button
							key={key}
							fullWidth
							variant="contained"
							onClick={() => handleOpenSimulatorClicked(key)}
							data-pendoid={`simulators__button__simulators-${key.replace("-simulator", "")}`}
							sx={{ whiteSpace: "nowrap", textOverflow: "ellipsis" }}
						>
							{label}
						</Button>
					))}
				</Grid>
			</CardContent>
		</Card>
	);
};
